import { Box, Breadcrumbs, styled } from "@mui/material";
import ndcBg from "../../../assets/images/ndc-bg.png";

export const StyledBox = styled(Box)(({ theme }) => ({
  height: "90%",
  backgroundColor: "#fff",
  borderRadius: ".625rem",
  overflowY: "scroll",
}));

export const Header = styled(Box)(({ theme }) => ({
  backgroundImage: `url(${ndcBg})`,
  minHeight: "6rem",
  display: "flex",
  backgroundSize: "cover",
}));

export const CustomBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
  "& li.MuiBreadcrumbs-separator": {
    margin: 0
  },
}));
